import React from 'react';
import { ImageAspectRatioType } from '../../../interfaces';
import { Layout } from '../../../queries/ats/layout/types';
import { getSectionItemImage } from '../../../utils/atsLayoutUtils';
import { classes } from '../../../utils/commonUtils';
import { Image } from '../../image/Image';
import { AtsItemOverwrites } from '../ats-asset/atsAsset.interfaces';
import { AtsItem } from '../AtsItem';
import styles from './AtsPerson.module.scss';

interface AtsPeopleProps {
  item: Layout.SectionItem;
  pattern: Layout.Pattern;
  overwrites?: AtsItemOverwrites;
}

export default function AtsPerson({ item, pattern, overwrites, ...rest }: AtsPeopleProps) {
  return (
    <article className={styles.person}>
      <AtsItem item={item} pattern={pattern} className={styles.link} overwrites={overwrites} {...rest}>
        <Image
          className={styles.image}
          src={getSectionItemImage(item, pattern, ImageAspectRatioType.SQUARE)}
          alt={item.name}
        />
        <p className={styles.title}>{item.name}</p>
      </AtsItem>
    </article>
  );
}

export function AtsPersonSkeleton() {
  return (
    <article className={classes(styles.person, styles.skeleton)}>
      <div className={styles.link}>
        <div className={styles.image} />
        <div className={styles.title} />
      </div>
    </article>
  );
}

AtsPerson.Skeleton = AtsPersonSkeleton;
